import { render, staticRenderFns } from "./store-group-filter.vue?vue&type=template&id=37b633a6&scoped=true"
import script from "./store-group-filter.vue?vue&type=script&lang=js"
export * from "./store-group-filter.vue?vue&type=script&lang=js"
import style0 from "./store-group-filter.vue?vue&type=style&index=0&id=37b633a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b633a6",
  null
  
)

export default component.exports